import React from 'react';

const steps = [
  {
    id: 1,
    name: 'Scan',
    description: 'Point your camera at any ingredient label, or let the extension scan automatically while you browse.',
    imageSrc: '/images/scan.png',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    id: 2,
    name: 'Analyze',
    description: 'Our AI instantly identifies seed oils, artificial dyes, sweeteners, and other ingredients you want to avoid.',
    imageSrc: '/images/analyze.png',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
  },
  {
    id: 3,
    name: 'Decide',
    description: 'Get a clear verdict so you can make an informed choice — buy with confidence or find a better alternative.',
    imageSrc: '/images/contrib.png',
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-surface py-16 md:py-20">
      <div className="section">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2 className="section-heading">How It Works</h2>
          <p className="section-subheading mx-auto">
            Three simple steps to healthier food choices.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className="relative animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Connector line (hidden on mobile, shown between items on desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-20 left-1/2 w-full h-0.5 bg-sage-200 -z-10" />
              )}

              <div className="text-center">
                {/* Step number with icon */}
                <div className="relative inline-flex mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-sage-100 flex items-center justify-center text-sage-600">
                    {step.icon}
                  </div>
                  <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-sage-500 text-white text-sm font-bold flex items-center justify-center">
                    {step.id}
                  </div>
                </div>

                {/* Step name */}
                <h3 className="font-display text-2xl text-charcoal mb-3">{step.name}</h3>

                {/* Description */}
                <p className="text-gray-500 leading-relaxed mb-6 max-w-xs mx-auto">
                  {step.description}
                </p>

                {/* Screenshot */}
                <div className="bg-gradient-to-b from-sage-50 to-sage-100 rounded-3xl p-4 shadow-soft">
                  <img
                    src={step.imageSrc}
                    alt={`Step ${step.id}: ${step.name}`}
                    className="w-full h-72 object-contain rounded-2xl"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
